import type { Effect, Reducer } from 'umi'
import {
  getImportStatus,
  importProject,
  projectCardList,
} from '@/services/leads'
import type { LeadsModelState } from './connect'

interface LeadsModelType {
  namespace: string
  state: LeadsModelState
  effects: {
    fetchProjectCardList: Effect
    importProjectExcel: Effect
    getImportStatus: Effect
    updateProjectCard: Effect
  }
  reducers: {
    saveProjectCardList: Reducer<LeadsModelState>
    updateProjectCard: Reducer<LeadsModelState>
    updateImportProjectStatus: Reducer<LeadsModelState>
  }
}

const initialState = {
  projectCardListData: [],
  projectCardListStatus: [],
  projectImport: {
    file: {
      name: '',
      status: '',
      percent: 0
    },
    hash: '',
    finish_flag: 2,
    total_project: 0,
    current_count: 0,
    success_count: 0,
    error_count: 0,
    existed_count: 0,
    existed_row: [],
    error_row: []
  },
  isImporting: false
}

const LeadsModel: LeadsModelType = {
  namespace: 'leads',
  state: initialState,
  effects: {
    *fetchProjectCardList({ payload }, { call, put }) {
      const response = yield call(projectCardList, payload)
      yield put({
        type: 'saveProjectCardList',
        payload: {
          data: response.data,
          page: payload.page || 1
        }
      })
    },
    *importProjectExcel({ payload }, { call, put, dispach }) {
      const response = yield call(importProject, payload)
      return new Promise((resolve, reject) => {
        if (response.code == 0) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    },
    *getImportStatus({ payload }, { call, put }) {
      const response = yield call(getImportStatus, payload)

      if (response.code == 0) {
        yield put({
          type: 'updateImportProjectStatus',
          payload: {
            data: response.data,
            isImporting: response.data.finish_flag == 1
          }
        })
      } else {
        yield put({
          type: 'updateImportProjectStatus',
          payload: {
            data: {
              file: {
                name: '',
                status: '',
                percent: 0
              },
              hash: '',
              finish_flag: 2,
              total_project: 0,
              current_count: 0,
              success_count: 0,
              error_count: 0,
              existed_count: 0,
              existed_row: [],
              error_row: []
            },
            isImporting: false
          }
        })
      }

      return new Promise((resolve, reject) => {
        if (response.code == 0) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    },
    updateProjectCard({ payload }, { put }) {
      put({
        type: 'updateProjectCard',
        payload
      })
    }
  },
  reducers: {
    saveProjectCardList(state = initialState, { payload }) {
      const { data, page } = payload
      let result = []

      if (page == 1) {
        result = data.cards || []
      } else {
        result = state?.projectCardListData || []
        result.forEach((item: any, index: number) => {
          item.list = item.list.concat(data.cards[index].list)
        })
      }

      return {
        ...state,
        projectCardListStatus: data.process_status,
        projectCardListData: result
      }
    },
    updateProjectCard(state = initialState, { payload }) {
      const temp = state?.projectCardListData || []
      const { id, name } = payload

      temp.forEach((item: any) => {
        item.list.forEach((sub: any) => {
          if (sub.id == id) {
            sub.processor_name_en = name
            if (sub.process_step == 1) {
              sub.process_step = 2
            }
          }
        })
      })

      return {
        ...state,
        projectCardListData: temp
      }
    },
    updateImportProjectStatus(state = initialState, { payload }) {
      const { data, isImporting } = payload

      return {
        ...state,
        projectImport: {
          ...state?.projectImport,
          ...data
        },
        isImporting
      }
    }
  }
}

export default LeadsModel
